import React, { useRef, useState, useEffect } from 'react'
import { Text, View, StyleSheet, Image, Dimensions, TouchableOpacity, Animated, ActivityIndicator, StatusBar } from 'react-native'
import BenefitsTabs from './benefitsTabs'
import { Platform } from 'react-native'
let BottomSheetFlatList, BottomSheetModal, BottomSheetModalProvider
if (Platform.OS !== 'web') {
    const bottomSheet = require('@gorhom/bottom-sheet')
    BottomSheetFlatList = bottomSheet.BottomSheetFlatList
    BottomSheetModal = bottomSheet.BottomSheetModal
    BottomSheetModalProvider = bottomSheet.BottomSheetModalProvider
}
import BenefitContext from './BenefitContext'
import { useNavigation, useRoute } from '@react-navigation/native'
import { find_color, useTheme } from '../appBar/context/HeaderContext'
import { useSetColor } from '../appBar/hooks/useSetColor'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import theme from '../../../theme'
import { useFetchBenefitHistory, useFetchBenefits } from './hooks/useFetchBenefits'
import { apiUrl } from '../../config/config'
import { fetchAuthSession } from 'aws-amplify/auth'
import { ScrollView } from 'react-native-gesture-handler'
import { getGoTo } from '../appBar/context/GoToContext'
import styles from './benefitsHomeStyles1'
import styles2 from './benefitsHomeStyles2'
import styles3 from './benefitsHomeStyles3'
import { placeholderGeneral } from '../customUtils/Constants'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { LinearGradient } from 'expo-linear-gradient'

const BenefitCard = ({ points }) => {
    const { languageFile } = getLanguage()
    //console.log('🚀 ~ BenefitCard ~ points:', points)
    return (
        <View style={styles3.invisibleContainer}>
            <LinearGradient
                style={styles3.container}
                colors={[theme.colors.linearGradientStart, theme.colors.linearGradientEnd]}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
            >
                <View style={[styles3.feedbackAssetContainer]}>
                    <Image style={[styles3.feedbackAsset]} source={require('../../../assets/benefitsPoints.png')} />
                </View>

                <View style={[styles3.levelKnowledgeBlock, styles3.alignStart]}>
                    <View>
                        {/*<Text style={[styles.titleNextModule, { fontSize: 14, textAlign: 'left', marginRight: 0 }]}>{languageFile.back}</Text>*/}

                        <View style={styles.containerData}>
                            <Text style={styles.title}>{languageFile.your_points}</Text>
                            <Text style={styles.value}>{points}</Text>
                        </View>

                        <Text style={[styles.subtitle]}>{languageFile.points_can_be_exchanged}</Text>
                    </View>
                </View>
            </LinearGradient>
        </View>
        /* MODAL INFERIOR
        <View style={styles3.invisibleContainer}>
            <View style={[styles3.feedbackAssetContainer]}>
                <Image style={[styles3.feedbackAsset]} source={require('../../../assets/benefitsPoints.png')} />
            </View>

            <View style={styles3.containerPoints}>
                <View style={{ width: '50%', alignItems: 'center' }}>
                    <Text style={styles.title}>{languageFile.your_points}</Text>
                    <Text style={styles.value}>{points}</Text>
                </View>
            </View>
        </View> */
    )
}

const BenefitDetailItem = (item) => {
    return (
        <View style={styles3.container}>
            <View>
                <Image source={{ uri: item?.cover_image ? item?.cover_image : placeholderGeneral }} style={styles3.imageHeader} />
            </View>
        </View>
    )
}

const BenefitsHome = () => {
    const [reloadPoints, setReloadPoints] = useState(0)
    console.log('🚀 ~ BenefitsHome ~ reloadPoints:', reloadPoints)
    const { points, dataRedeems, dataPoints, isLoading: historyLoading, reload, fetch_data, setIsLoading, setReloadCounter } = useFetchBenefitHistory()
    //console.log('🚀 ~ BenefitCard ~ points:', points)
    const bottomSheetRef = useRef(null)
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()

    // const navigation = useNavigation()
    // useRoute() may throw if component is rendered outside a navigator (web bypass).
    // Provide a safe fallback route name to avoid crashing on web.
    let routeName = 'BenefitsHome'
    try {
        const route = useRoute()
        routeName = route?.name || routeName
    } catch (e) {
        // Not inside a navigation context (expected when rendering via NavigationStack web bypass)
    }

    // useSetColor controls theme background; its loading flag is tied to navigation focus
    // and may never fire in the web bypass. Do not use it to gate UI loading state.
    const { isLoading: colorLoading } = useSetColor(routeName)
    const { benefit, setBenefit } = getGoTo()

    function handleSheetChanges(index) {
        console.log('handleSheetChanges', index)
    }

    const snapPoints = ['80%']

    function handlePresentModal(item) {
        console.log(`handlePresentModal show: ${item.title}`)
        openBottomSheet(<BenefitsSheetItem item={item} setReloadPoints={setReloadPoints} closeBottomShet={closeBottomSheet} fetchHome={setFetch} />)
    }
    useEffect(() => {
        setIsLoading(true)
        setFetch()
    }, [reloadPoints, reload])

    const setFetch = () => {
        fetch_data().then(() => {
            if (benefit != null) {
                handlePresentModal(benefit)
                setBenefit(null)
            }
        })
    }
    return (
        <View style={styles.container}>
            {historyLoading ? (
                <ActivityIndicator />
            ) : (
                <BenefitContext.Provider value={handlePresentModal}>
                    <BenefitsTabs dataRedeems={dataRedeems} points={points ? points : 0} />
                    {Platform.OS === 'web' ? (
                        <View style={{ padding: 24, alignItems: 'center' }}>
                            <Text style={{ fontSize: 18, color: 'red' }}>{"Funcionalidad no disponible en web"}</Text>
                        </View>
                    ) : (
                        // <BottomSheetFlatList
                        //     data={dataRedeems}
                        //     keyExtractor={(item) => item._id}
                        //     renderItem={renderBenefit}
                        //     contentContainerStyle={{ paddingBottom: 80 }}
                        // />
                        <></>
                    )}
                </BenefitContext.Provider>
            )}
        </View>
    )
}

export default BenefitsHome

export const BenefitsSheetItem = ({ item, setReloadPoints, closeBottomShet, fetchHome }) => {
    const [showMessage, setShowMessage] = useState(false)
    const [image, setImagePath] = useState('')
    const [message, setMessage] = useState('')
    const [description, setDescription] = useState('')
    const { languageFile } = getLanguage()
    let array_images = [{ _id: 1, cover_image: item.cover_image }]
    const redeemBenefit = async (benefit_id) => {
        console.log('🚀 ~ redeemBenefit ~ benefit_id:', benefit_id)
        try {
            if (benefit_id) {
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString()
                let headers = {
                    'Content-Type': 'application/json',
                    Authorization: authToken,
                    benefit_id: benefit_id,
                }

                const response = await fetch(`${apiUrl}/redeem_benefit`, {
                    method: 'POST',
                    headers: headers,
                })

                if (!response.ok) {
                    const errorResponse = await response.json()
                    throw new Error(
                        `Fallo al agregar el redeem_benefit. Código de estado: ${response.status}. Detalles: ${JSON.stringify(errorResponse)}`,
                    )
                }

                const data = await response.json()
                if (data.single.status === 1) {
                    // Beneficio redimido con éxito
                    setShowMessage(true)
                    setImagePath(require('../../../assets/benefitPending.png'))
                    setMessage(languageFile.pending_approval)
                    setDescription(languageFile.when_it_is_approved)
                    fetchHome()
                } else if (data.single.status === -1) {
                    // No tiene suficientes puntos
                    setShowMessage(true)
                    setImagePath(require('../../../assets/voucherCancelled.png'))
                    setMessage(languageFile.unredeemed_benefit)
                    setDescription(languageFile.you_dont_have_enough_points)
                }

                setReloadPoints((prevCounter) => prevCounter + 1)
            }
        } catch (error) {
            console.log('🚀 ~ redeemBenefit ~ error:', error)
        }
    }
    return (
        <View style={styles2.contentContainer}>
            {/* <StatusBar backgroundColor={'transparent'} barStyle='light-content' /> */}
            {showMessage ? (
                <>
                    <ScrollView showsVerticalScrollIndicator={false}>
                        <View style={styles2.messageContainer}>
                            {image && (
                                <View>
                                    <Image style={styles2.benefitAsset} source={image} />
                                </View>
                            )}

                            {message && <Text style={styles2.messageText}>{message}</Text>}

                            {description && <Text style={styles2.descriptionText}>{description}</Text>}
                        </View>
                        <View style={styles2.spacer2}></View>
                    </ScrollView>
                    <View style={styles2.buttonContainer}>
                        <TouchableOpacity onPress={() => closeBottomShet(true)} style={[styles2.mainButton]}>
                            <Text style={styles2.mainButtonText}>{languageFile.accept}</Text>
                        </TouchableOpacity>
                    </View>
                </>
            ) : (
                <>
                    <ScrollView showsVerticalScrollIndicator={false}>
                        <View style={styles2.mediaContainer}>
                            {/*<BottomSheetFlatList
                                data={array_images}
                                keyExtractor={(item) => item._id}
                                horizontal={true}
                                showsVerticalScrollIndicator={false}
                                showsHorizontalScrollIndicator={false}
                                renderItem={({ item }) => <BenefitDetailItem {...item} />}
                            />*/}
                            <Image source={{ uri: item?.cover_image ? item?.cover_image : placeholderGeneral }} style={styles3.imageHeader} />
                        </View>

                        <View style={styles2.infoContainer}>
                            {item.title && <Text style={styles2.title}>{item.title ?? ''}</Text>}

                            {item.points && (
                                <Text style={styles2.price}>
                                    {item.points ?? ''}
                                    {languageFile.points}
                                </Text>
                            )}
                            {item.stock && (
                                <View style={styles2.containerStock}>
                                    <Text style={styles2.stock}>
                                        {item.stock ?? ''}
                                        {languageFile.units_available}
                                    </Text>
                                </View>
                            )}

                            {/* <Text style={styles2.description}>{item.description_short}</Text> */}
                            {item.description_long && <Text style={styles2.description ?? ''}>{item.description_long}</Text>}
                        </View>
                        <View style={styles2.spacer2}></View>
                    </ScrollView>

                    <View style={styles2.buttonContainer}>
                        <TouchableOpacity onPress={() => redeemBenefit(item._id)} style={styles2.mainButton}>
                            <Text style={styles2.mainButtonText}>{languageFile.redeem_benefit}</Text>
                        </TouchableOpacity>
                    </View>
                </>
            )}
        </View>
    )
}
